// extracted by mini-css-extract-plugin
export default {"wrap":"sz-z","fullWidth":"tz-z","searchPlacement":"uz-z","items":"vz-z","featureCss":"wz-z","disabled":"xz-z","imgCss":"yz-z"};